/*
* Salla Rating Component: Order rating modal, used in the order single page
* You can use these classes to target the elements in the component.
*/

.s-rating-modal {
  &-wrapper {

  }
  &-footer {

  }
  &-btn {

  }
  &-dots {

  }
  &-step-dot {

  }
  &-step {

  }
  &-active {

  }
  &-unactive {

  }
  &-hidden {

  }
  &-unvisiable {

  }
  &-step-wrap {

  }
  &-product-details {

  }
  &-rounded-icon {

  }
  &-title {

  }
  &-store-logo {

  }
  &-shipping-logo {

  }
  &-shipping-icon {

  }
  &-comment {

  }
  &-validation-msg {

  }
  &-product {

  }
  &-product-img {
    
  }
  &-product-title {

  }
  &-thanks {

  }
  &-icon {

  }
  &-thanks-msg {

  }
  &-thanks-btn {

  }
  &-thanks-time {

  }
  &-btn-star {

  }
  &-btn-star-large {

  }
  &-btn-star-small {

  }
  &-hovered {

  }
  &-selected {

  }
  &-stars-company {

  }
  &-stars-product {

  }
  &-bg-gray {

  }
  &-bg-primary {

  }
} 
